import { cssTheme } from '@uds/theme-utils';
import { Alignment } from 'domain/constants/alignment';
import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import { ResponsiveSet } from 'core/ribbons/primitives';

interface InnerProps {
  hasMultipleCtas: boolean;
  alignment: Alignment;
}

const centerAligned = css`
  text-align: center;
`;

const ctas = {
  default: css`
    margin-top: ${cssTheme.gu2};
  `,
  spaced: css`
    &&& {
      ${cssTheme.breakpoints.sm} {
        width: 100%;
      }
    }
  `,
};

const cta = {
  default: css`
    margin-top: ${cssTheme.gu1};
  `,
  spaced: css`
    &&& {
      ${cssTheme.breakpoints.sm} {
        margin-right: ${cssTheme.gu1};
        display: inline-block;
      }
      :last-of-type {
        margin-right: 0;
      }
    }
  `,
};

const body = {
  default: css`
    text-align: left;
    margin-top: ${cssTheme.gu3};
    grid-column-gap: ${cssTheme.gu3};
    column-gap: ${cssTheme.gu3};
    &&& {
      ${cssTheme.breakpoints.lg} {
        grid-column-gap: ${cssTheme.gu4};
        column-gap: ${cssTheme.gu4};
      }
    }
  `,
  centerAligned: css`
    text-align: center;
    column-count: 1;
  `,
};

const subtitle = {
  default: css`
    margin-top: ${cssTheme.gu2};
  `,
};

interface BodyProps {
  columnCount: ResponsiveSet<number>;
}

export const StyledBody = styled.div<BodyProps>`
  column-count: ${(props) => props.columnCount[0]};
  &&& {
    ${cssTheme.breakpoints.sm} {
      column-count: ${(props) => props.columnCount[1]};
    }
  }
  &&& {
    ${cssTheme.breakpoints.lg} {
      column-count: ${(props) => props.columnCount[2]};
    }
  }
`;

export default ({ alignment, hasMultipleCtas }: InnerProps) => {
  return {
    header: cx(alignment === Alignment.CENTER && centerAligned),
    cta: cx(cta.default, hasMultipleCtas && cta.spaced),
    ctas: cx(ctas.default, hasMultipleCtas && ctas.spaced, alignment === Alignment.CENTER && centerAligned),
    body: cx(body.default, alignment === Alignment.CENTER && body.centerAligned),
    subtitle: subtitle.default,
  };
};
